module.exports = __webpack_public_path__ + "img/trash-icon.30adbdc4.svg";